import { render, staticRenderFns } from "./course-detail.vue?vue&type=template&id=ec4dd2d2&scoped=true&"
import script from "./course-detail.vue?vue&type=script&lang=js&"
export * from "./course-detail.vue?vue&type=script&lang=js&"
import style0 from "./course-detail.vue?vue&type=style&index=0&id=ec4dd2d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4dd2d2",
  null
  
)

export default component.exports